// Corporate Warm — healthcare, HR, hospitality, education
// Warm whites + deep rose/burgundy, friendly pill buttons
module.exports = {
  effect: 'none',
  colors: {
    main:            { light: '#fdf8f6', dark: '#180a0a' },
    card:            { light: '#f5edea', dark: '#251010' },
    surface:         { light: '#ead9d4', dark: '#301818' },
    action:          { light: '#881337', dark: '#fb7185' },
    actionHover:     { light: '#6b0f2d', dark: '#f43f5e' },
    textPrimary:     { light: '#1c0a0a', dark: '#fdf2f2' },
    textSecondary:   { light: '#3d1515', dark: '#f0c8c8' },
    textMuted:       { light: '#7c4040', dark: '#d09090' },
    textMutedSubtle: { light: '#a06060', dark: '#a06060' },
    border:          { light: '#c9a0a0', dark: '#4a2020' },
    borderSubtle:    { light: '#e0c4c4', dark: '#381818' },
    link:            { light: '#881337', dark: '#fb7185' },
    linkBg:          { light: '#fff1f2', dark: 'rgba(136,19,55,0.15)' },
    linkBorder:      { light: '#fecdd3', dark: '#881337' },
    linkHover:       { light: '#ffe4e6', dark: 'rgba(136,19,55,0.28)' },
    inputBg:         { light: '#ffffff', dark: '#251010' },
    inputBorder:     { light: '#c9a0a0', dark: '#4a2020' },
    inputText:       { light: '#1c0a0a', dark: '#fdf2f2' },
    focusRing:       { light: '#881337', dark: '#fb7185' },
    overlay:         { light: 'rgba(0,0,0,0.5)', dark: 'rgba(0,0,0,0.78)' },
    confirm:         { light: '#a06060', dark: '#4a2020' },
    confirmHover:    { light: '#7c4040', dark: '#5a2e2e' },
    confirmText:     { light: '#ffffff', dark: '#fdf2f2' },
    confirmBg:       { light: '#fdf8f6', dark: '#251010' },
    confirmBorder:   { light: '#e0c4c4', dark: '#4a2020' },
    success:         { light: '#065f46', dark: '#34d399' },
    successHover:    { light: '#022c22', dark: '#10b981' },
    successBg:       { light: '#ecfdf5', dark: 'rgba(6,78,59,0.3)' },
    successText:     { light: '#10b981', dark: '#6ee7b7' },
    successBorder:   { light: '#a7f3d0', dark: '#065f46' },
    error:           { light: '#b91c1c', dark: '#f87171' },
    errorHover:      { light: '#991b1b', dark: '#ef4444' },
    errorBg:         { light: '#fef2f2', dark: 'rgba(127,29,29,0.3)' },
    errorText:       { light: '#ef4444', dark: '#fca5a5' },
    errorBorder:     { light: '#fecaca', dark: '#7f1d1d' },
    info:            { light: '#1e40af', dark: '#60a5fa' },
    infoHover:       { light: '#1d4ed8', dark: '#3b82f6' },
    infoBg:          { light: '#eff6ff', dark: 'rgba(30,58,138,0.3)' },
    infoText:        { light: '#3b82f6', dark: '#93c5fd' },
    infoBorder:      { light: '#bfdbfe', dark: '#1e3a8a' },
  },
  borderRadius: {
    card:      '28px',
    container: '18px',
    page:      '24px',
    button:    '9999px',
    input:     '14px',
    badge:     '8px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '5px',
    device:  '7px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
